module.exports = __webpack_public_path__ + "img/ncsu-logo.5517a7e9.jpg";